import * as Sentry from '@sentry/react'
import { Auth0ClientConfig } from './auth0-client-config'

const buildAuth0ClientConfig = (
  country: Auth0ClientConfig['country'],
  cookieDomain?: string,
  consumerUrl?: string
): Auth0ClientConfig => {
  return {
    cookieDomain: cookieDomain || '',
    consumerUrl: consumerUrl || '',
    country,
  }
}

const getAuth0ClientConfig = (clientId: string) => {
  const auClientId = import.meta.env.REACT_APP_AUTH0_AU_CLIENT_ID
  const nzClientId = import.meta.env.REACT_APP_AUTH0_NZ_CLIENT_ID

  if (!auClientId) {
    throw new Error('No REACT_APP_AUTH0_AU_CLIENT_ID configured')
  }

  if (!nzClientId) {
    throw new Error('No REACT_APP_AUTH0_NZ_CLIENT_ID configured')
  }

  const auAuth0ClientConfig = buildAuth0ClientConfig(
    'Australia',
    import.meta.env.REACT_APP_AU_COOKIE_DOMAIN,
    import.meta.env.REACT_APP_AU_CONSUMER_URL
  )

  const nzAuth0ClientConfig = buildAuth0ClientConfig(
    'New Zealand',
    import.meta.env.REACT_APP_NZ_COOKIE_DOMAIN,
    import.meta.env.REACT_APP_NZ_CONSUMER_URL
  )

  // Default to AU config in case of missing client id and/or non-configured client
  let config = auAuth0ClientConfig

  if (clientId) {
    if (clientId === auClientId) {
      config = auAuth0ClientConfig
    } else if (clientId === nzClientId) {
      config = nzAuth0ClientConfig
    } else {
      // No matching client config for the specified client id,
      Sentry.captureEvent({
        message: `No matching auth0 client configuration with client id ${clientId}, defaulting to AU client`,
        level: 'error',
      })
    }
  } else {
    // No client id specified
    Sentry.captureEvent({
      message: `No auth0 client id specified, defaulting to AU client`,
      level: 'error',
    })
  }

  const missingConfigValues = Object.entries(config).reduce(
    (result, [prop, value]) => (value ? result : result.concat(prop)),
    new Array<string>()
  )

  if (missingConfigValues.length) {
    throw new Error(
      `Incomplete auth0 client configuration (for client with id ${clientId || 'N/A'}) - Missing '${missingConfigValues.join("', '")}'`
    )
  }

  return config
}

export default getAuth0ClientConfig
